var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowTrendUp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M576 120V296C576 309.25 565.25 320 552 320S528 309.25 528 296V177.938L336.969 368.969C332.281 373.656 326.141 376 320 376S307.719 373.656 303.031 368.969L192 257.938L40.969 408.969C36.281 413.656 30.156 416 24 416C5.205 416 0 398.802 0 392C0 385.859 2.344 379.719 7.031 375.031L175.031 207.031C179.719 202.344 185.859 200 192 200S204.281 202.344 208.969 207.031L320 318.062L494.062 144H376C362.75 144 352 133.25 352 120S362.75 96 376 96H552C565.25 96 576 106.75 576 120Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowTrendUp);
export default __webpack_public_path__ + "static/media/arrow-trend-up.ad5d21ba45cef84ba905b9b889b97d83.svg";
export { ForwardRef as ReactComponent };